const tabs = document.querySelectorAll(".tabs .tab");
const underline = document.querySelector(".tabs__underline");
const panels = document.querySelectorAll(".tab-panel");

function moveUnderline(activeTab) {
  underline.style.width = `${activeTab.offsetWidth}px`;
  underline.style.transform = `translateX(${activeTab.offsetLeft}px)`;
}

// init on load
const active = document.querySelector(".tab.is-active");
if (active) moveUnderline(active);

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    // update active tab
    tabs.forEach((t) => t.classList.remove("is-active"));
    tab.classList.add("is-active");

    // update panels
    panels.forEach((p) => p.classList.remove("is-active"));
    document.getElementById(tab.dataset.tab).classList.add("is-active");

    // move underline
    moveUnderline(tab);
  });
});
